import { forEach } from 'lodash'
import { db, rtdb } from "@/plugins/firebase";
import helpers from "@/mixins/helpers";


export default {
  mixins: [ helpers ],
  data() {
    return {
      rtdbRefs: {},
      dbRefs: {},
      dbLoaders: {}
    }
  },
  beforeDestroy() {
    this.$unbindAll()
  },
  methods: {
    _refPath(ref) {
      return ref.toString().substring(rtdb.ref().root.toString().length-1);
    },
    _setLoader(state, loader, key) {
      if (!loader) return
      if (typeof loader === 'boolean') {
        this.$set(this.dbLoaders, '_default', { [key]: state })
      } else {
        this.$set(this.dbLoaders, loader, { [key]: state })
      }
    },
    $bindRtdbStore(mutation, ref, options = {}) {
      const callback = (v) => this.$store.commit(mutation, v)

      this.$bindRtdb(mutation, ref, { callback, ...options})
    },
    $bindRtdb(key, ref, options = {}) {
      const { callback, loader, defaultData = {} } = options

      let setLoader = (state) => this._setLoader(state, loader, key)
      
      const rtdbRef = typeof ref === 'string'
        ? rtdb.ref(ref)
        : ref
      
      const dataCallback = callback 
        ? callback
        : (data) => this[key] = data
      
      setLoader(true)

      if (this.rtdbRefs[key]) this.rtdbRefs[key].off()
      this.rtdbRefs[key] = rtdbRef
      rtdbRef.on('value', s => {
        dataCallback(s.val() || defaultData)
        setLoader(false)
      })
    },
    /**
     * 
     * @param {String | Firebase.Firestore} ref Document/Collection path as string or Firestore instance
     * @param {String | Function} dataCallback String value representing key of data or callback function
     * @param {Boolean | String} loader Pass True to set Vuex _loader or pass string value representing key of data to set as loader
     */
    $bindDb(key, ref, options = {}) {
      const { callback, loader, defaultData = {} } = options
      
      const refType = typeof ref === 'string'
        ? ref.split('/').length % 2 === 0
          ? 'doc'
          : 'collection'
        : null

      const dbRef = typeof ref === 'object'
        ? ref
        : db[refType](ref)

      const setLoader = (state) => this._setLoader(state, loader, key)

      const dataCallback = callback 
        ? callback
        : (data) => this[key] = data

      setLoader(true)

      if (this.dbRefs[key]) this.dbRefs[key]()

      this.dbRefs[key] = dbRef
        .onSnapshot(s => {
          let data = refType === 'doc'
            ? s.data() || defaultData
            : this._querySnapshotToArray(s)
          dataCallback(data)
          setLoader(false)
        })
    },
    $unbind(key) {
      if (this.rtdbRefs[key]) this.rtdbRefs[key].off()
      
    },
    $unbindDb(key) {
      if (this.dbRefs[key]) this.dbRefs[key]()
    },
    $unbindAll() {
      forEach(this.rtdbRefs, ref => {
        if (ref) ref.off()
      })
      forEach(this.dbRefs, ref => {
        if (ref) ref()
      })
    }
  },
  watch: {
    dbLoaders: {
      handler() {
        forEach(this.dbLoaders, (loader, loaderId) => {
          let state = Object.keys(loader).every(k => loader[k])
          if (loaderId === '_default') {
            this.$store.commit('set_loader', state)
          } else {
            this[loaderId] = state
          }
        })
      },
      deep: true
    }
  }
}
